import React, { useRef } from 'react'
import { Select } from 'antd'
import { useStore } from '../../../store/store'
import { useQueryDocumentSections } from '../../../hooks'
import { searchCaseDiatricsInsensitive } from '../../../utils/general'
const { Option } = Select;

const selector =
  ({
    currentDocument,
    currentProposal,
  }) => {
    return {
      documentType: currentDocument.type,
      documentId: currentDocument.type === 'template' ? currentDocument.id : currentProposal.id,
    }
  };

const FormSectionBox = ({ value, onSelect, fromPopover, ...props }) => {
  const {
    documentType,
    documentId,
  } = useStore(selector);

  // Validation locale pour éviter les erreurs
  const isValidDocumentId = documentId && documentId !== null && documentId !== undefined && documentId !== 'undefined';

  console.log('FormSectionBox - documentType:', documentType, 'documentId:', documentId, 'isValid:', isValidDocumentId);

  const { data: sectionList, error, isLoading } = useQueryDocumentSections(
    { documentType, documentId },
    {
      enabled: isValidDocumentId,
      onError: (error) => {
        console.error('FormSectionBox - Erreur lors de la récupération des sections:', error);
      }
    }
  );

  const ref = useRef()

  // Afficher un message d'erreur si l'ID est invalide
  if (!isValidDocumentId) {
    console.warn('FormSectionBox: documentId invalide, impossible de charger les sections');
  }


  return (
    <Select
      ref={ref}
      style={{
        flex: 1,
        width: '100%',
      }}
      value={value ?? undefined}
      onSelect={(...props) => {
        if (typeof onSelect === 'function')
          onSelect(...props)
        ref.current.blur()
      }}
      dropdownMatchSelectWidth={false}
      optionLabelProp="label"
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) => {
        return searchCaseDiatricsInsensitive(input, option?.label);
      }}
      styles={{ popup: { root: { zIndex: 9999 } } }}
      getPopupContainer={triggerNode => fromPopover ? triggerNode.parentElement : triggerNode.ownerDocument.body}
      placement="bottomLeft"
      allowClear
      onClear={onSelect}
      loading={isLoading}
      disabled={!isValidDocumentId}
      placeholder={!isValidDocumentId ? "Chargement..." : "Sélectionner une section"}
      {...props}
    >
      {(sectionList || []).map(({ name, id, preview }) => {
        return (
          <Option key={id} value={id} label={name}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <div style={{
                whiteSpace: 'break-spaces',
                wordWrap: 'break-word',
              }}>
                {name}
              </div>
            </div>
          </Option>
        )
      })}
    </Select>
  )
}

export default FormSectionBox
